import React, { Component, useRef } from 'react';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import './CurrentStoreMenuItemGrid.css';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/image.min.css';
import { AppContext } from '../../../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';

class CurrentStoreMenuGridItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {scanData, onClick, onHover, onUnhover} = this.props;
        return (
            <li key={scanData.scene_id} onClick={() => onClick(scanData.scene_id)} onMouseOver={() => onHover()} onMouseOut={() => onUnhover()}>
                <div style={{ backgroundImage: `url(${scanData.img})`}}>
                    <span className="categoryTitle">{scanData.name}</span>
                </div>
                
            </li>
        );
    }
}

CurrentStoreMenuGridItem.propTypes = {
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    onClick: PropTypes.func,
    scanData: PropTypes.object
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContext => (
                    <CurrentStoreMenuGridItem
                        {...props}
                        threeJSWorldContext={threeJSWorldContext}
                        setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                    />
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);
